import React from "react";
import Entities from "../../components/Entities";
import { getRepresentativesWithSync } from "../../API";

export async function loader() {
  return getRepresentativesWithSync();
}

const isSyncBad = (rep) =>
  (rep.uploadVisitStep != null && rep.uploadVisitStep < 4) ||
  (rep.syncDataStep != null && rep.syncDataStep < 12);

const formatSyncDate = (epochMs) =>
  epochMs ? new Date(epochMs).toLocaleString() : "";

function Representatives() {
  return (
    <Entities
      shema={{
        searchFromServer: false,
        fields: [
          { name: "Last Name", propertyName: "lastName", search: true },
          { name: "First Name", propertyName: "firstName", search: true },
          {
            name: "Last Sync",
            renderCell: (rep, key) => (
              <td key={key} style={isSyncBad(rep) ? { color: "red" } : {}}>
                {formatSyncDate(rep.lastSyncDate)}
              </td>
            ),
          },
          { name: "Version", propertyName: "version" },
          { name: "Territories", propertyName: "territories", isArray: true },
        ],
      }}
    />
  );
}

export default Representatives;
